
import AuthProvider from "./auth-provider";

export default class RdstvAuthProvider extends AuthProvider {
  constructor() {
    super('rdstv');
  }

  authorize() {
    fetch('https://rdstv.ru/local/php_interface/webcaster/auth.php',{
      method:'get',
      credentials: 'include'
    }).then((response) => {
      if (!response.ok) {
        console.warn(`Can't authorize in chat due to unsuccessful response from RDStv with code ${response.status}`);
        return;
      }

      response.json().then((json) => {
        if (json.authorized == 0) return;

        let auth_chat_name = json.nicname ? json.nicname : json.name;
        let userData = { name: auth_chat_name };

        this.trigger({
          type: 'providerConfirmedAuthorization',
          data: {
            provider: this.name,
            userData: userData
          }
        });
      });
    })
    .catch((error) => {
      console.log({ error });
    });
  }

  isUserAuthorized() {
    return true;
  }

  loadScript() {
      this.trigger('scriptLoaded');
  }
}